<template>
  <div>
    <!-- Temporary debug section -->
    <!-- <pre>{{ customers }}</pre> -->
    <!-- <pre>
      {{ pwResetLogArray }}
    </pre> -->
    <pre v-if="debugMode">
     customers {{ customers }}
    </pre>

    <!-- Advanced Search Section -->
    <div class="advanced-search-container mb-6 p-4 border rounded-lg">
      <h3 class="text-lg font-bold mb-3">Advanced Search</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <v-text-field
            v-model="advancedSearch.email"
            label="Search by Email"
            placeholder="example@email.com"
            outlined
            dense
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="advancedSearch.userId"
            label="Search by User ID"
            placeholder="259b5356-3489..."
            outlined
            dense
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="advancedSearch.customerCode"
            label="Search by Customer Code"
            placeholder="10106166"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <div class="flex justify-end mt-2 space-x-2">
        <v-btn
          color="primary"
          @click="searchSpecificUser"
          :loading="searchLoading"
          :disabled="!isAdvancedSearchValid"
        >
          Search
        </v-btn>
        <v-btn v-if="isInSearchMode" @click="clearAdvancedSearch">
          Clear Search
        </v-btn>
      </div>
    </div>

    <!-- Search for filtering the table -->

    <!-- Search results indicator -->
    <div v-if="isInSearchMode" class="mb-4 p-2 bg-blue-100 rounded-lg">
      <div class="flex justify-between items-center">
        <span class="font-semibold">
          Showing {{ searchResultCount }} search results out of
          {{ totalUsersSignedUp }} total users
        </span>
        <v-btn small text color="primary" @click="getCustomers">
          Return to all customers
        </v-btn>
      </div>
    </div>

    <div class="text-center text-xl font-bold border-gray-400 border-b-2">
      List of buyers who have signed up to the portal - {{ totalUsersSignedUp }}
    </div>

    <v-data-table
      :headers="headers"
      :items="customers"
      :loading="loading"
      :search="search"
    >
      <template v-slot:top>
        <v-progress-linear
          v-if="progress_bar"
          :indeterminate="indeterminate"
        ></v-progress-linear>
      </template>
      <template v-slot:[`item.customer_code_new`]="{ item }">
        {{ item.customer_code_new || "N/A" }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.status ? 'green' : 'red'" text-color="white">
          {{ item.status ? "Reset link sent" : "--" }}
        </v-chip>
      </template>
      <template v-slot:[`item.myLastSignIn`]="{ item }">
        <!-- {{ formatDate(item.myLastSignIn) }} -->
        {{ item.myLastSignIn ? formatDate(item.myLastSignIn) : "Never" }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <!-- v-if="!item.myLastSignIn" -->
        <div class="space-x-2 flex">
          <v-btn
            small
            color="primary"
            @click="sendResetPwLink(item)"
            :loading="item.sending"
          >
            Send Reset Link
          </v-btn>
          <v-btn color="secondary" small @click="openUserDetails(item)">
            Details
          </v-btn>
        </div>
      </template>
      <!-- <template v-slot:[`item.last_sign_in_at`]="{ item }"> -->
      <!-- {{ item.last_sign_in_at ? formatLastSignIn(item.last_sign_in_at) : "Never" }} -->
      <!-- {{ item.last_sign_in_at }} -->
      <!-- {{ item.last_sign_in_at ? formatDate(item.last_sign_in_at) : "Never" }} -->
      <!-- </template> -->
      <template v-slot:[`item.emailLinkSentDate`]="{ item }">
        <div class="flex items-center">
          {{
            item.emailLinkSentDate
              ? formatDate(item.emailLinkSentDate)
              : "Never"
          }}
          <v-icon v-if="item.status" color="green" class="ml-2">
            mdi-check-circle
          </v-icon>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-model="userDetailsDialog"
      persistent
      :overlay="false"
      max-width="600px"
      transition="dialog-transition"
    >
      <UserDetails
        :userDetails="userDetails"
        :userEmail="userEmail"
        @closeUserDetails="closeUserDetails"
      />
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import UserDetails from "./components/UserDetails.vue";
import moment from "moment-timezone";

export default {
  data() {
    return {
      theCustomersResponse: [],
      userEmail: "",
      userDetails: [],
      userDetailsDialog: false,
      pwResetLogArray: [],
      totalUsersSignedUp: 0,
      globalProgress: false,
      progress_bar: false,
      indeterminate: false,
      openPw: false,
      search: "",
      headers: [
        {
          text: "Customer Code",
          value: "customerCodeNew",
        },
        {
          text: "Email Address",
          value: "email",
        },
        // {
        //   text: "Password Reset Status",
        //   value: "status",
        // },
        {
          text: "Email Link Sent",
          value: "emailLinkSentDate",
        },
        {
          text: "Last Sign In",
          value: "myLastSignIn",
        },

        {
          text: "Actions",
          value: "action",
          sortable: false,
        },
      ],
      loading: false,
      customers: [],

      // New properties for advanced search
      debugMode: false,
      advancedSearch: {
        email: "",
        userId: "",
        customerCode: "",
      },
      searchLoading: false,
      isInSearchMode: false,
      originalCustomers: [], // To store the full list when in search mode
      searchResultCount: 0, // Add this new property
    };
  },
  components: {
    UserDetails,
  },
  computed: {
    isAdvancedSearchValid() {
      // At least one search field must be filled
      return (
        this.advancedSearch.email.trim() !== "" ||
        this.advancedSearch.userId.trim() !== "" ||
        this.advancedSearch.customerCode.trim() !== ""
      );
    },
  },
  methods: {
    closeUserDetails() {
      this.userDetailsDialog = false;
    },
    async getSelectedUserDetails(email) {
      try {
        const response = await axios.post(`/users/getUserDetails`, {
          email,
        });
        // Handle the response as needed, e.g., update local state or display data
        return response.data;
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    },
    async openUserDetails(item) {
      //  open the user_details console log the item
      const info = await this.getSelectedUserDetails(item.email);
      if (info.length > 0) {
        this.userDetailsDialog = true;
        this.userDetails = info;
        this.userEmail = item.email;
      }
    },
    progress_bar_on(e) {
      this.progress_bar = e;
      this.indeterminate = e;
    },
    async sendResetPwLink(item) {
      item.sending = true; // Show progress bar
      const data = {
        email: item.email,
        buyer_name: item.buyer_name,
      };
      this.progress_bar_on(true);
      try {
        const response = await axios.post("/password/send_reset_link", data);
        const errorMessage =
          response.data.message ||
          "An error occurred while sending the reset link.";
        if (!response.data.status) {
          alert(errorMessage); // Alert the user if the reset link was not sent successfully
        }
        if (response.data.status === undefined) {
          console.warn(
            "Response status is undefined. Check the API response structure."
          );
        }
        if (response.data.status) {
          const now = new Date().toISOString();
          item.status = true; // Set status to true
          item.date = now;

          // Update customers array directly
          const customerIndex = this.customers.findIndex((c) => {
            return c.email === item.email; // Corrected: return statement added
          });
          if (customerIndex !== -1) {
            this.customers[customerIndex].status = true; // Update status in customers array
            this.customers[customerIndex].date = now; // Update date in customers array
            this.customers[customerIndex].emailLinkSentDate = now; // Update emailLinkSentDate
          }

          localStorage.setItem(`pw_reset_status_${item.email}`, "success");
          localStorage.setItem(`pw_reset_date_${item.email}`, now);
        }
      } catch (error) {
        console.error("Failed to send password reset link:", error);
      } finally {
        item.sending = false; // Hide progress bar
        this.progress_bar_on(false);
      }
    },

    async getCustomers() {
      console.log("getCustomers method called");
      if (this.loading) {
        console.log("Already loading, skipping request");
        return;
      }
      this.loading = true;
      this.isInSearchMode = false; // Reset search mode when fetching all

      try {
        console.log("Making request to /users/getCustomersWithResetLog");
        // Call the endpoint
        const response = await axios.get("/users/getCustomersWithResetLog");
        console.log("Response received:", response.data);

        // Use the combined data
        this.customers = response.data.data;
        this.originalCustomers = [...response.data.data]; // Store a copy
        this.totalUsersSignedUp = response.data.totalUsers;
        console.log("Total users signed up:", this.totalUsersSignedUp);
      } catch (error) {
        console.error("Error fetching customer data:", error);
      } finally {
        this.loading = false;
        console.log("Loading complete");
      }
    },
    statusClass(item) {
      return item.status // Change from item.pw_reset_status to item.status
        ? "bg-green-200 text-green-800"
        : "bg-red-200 text-red-800";
    },

    formatDate(dateString) {
      // Check if the dateString is valid
      if (!dateString || !moment(dateString).isValid()) return "N/A";

      // Parse the date as UTC and convert to Asia/Manila timezone
      return moment
        .utc(dateString)
        .tz("Asia/Manila")
        .format("lll");
    },

    // Add new methods for advanced search
    async searchSpecificUser() {
      if (!this.isAdvancedSearchValid) return;

      this.searchLoading = true;

      try {
        // Build query parameters
        const params = new URLSearchParams();
        if (this.advancedSearch.email)
          params.append("email", this.advancedSearch.email);
        if (this.advancedSearch.userId)
          params.append("userId", this.advancedSearch.userId);
        if (this.advancedSearch.customerCode)
          params.append("customerCode", this.advancedSearch.customerCode);

        // Make API request
        const response = await axios.get(
          `/users/searchUser?${params.toString()}`
        );

        if (response.data.status) {
          // Store original customers if this is the first search
          if (!this.isInSearchMode) {
            this.originalCustomers = [...this.customers];
          }

          // Update customers with search results
          this.customers = response.data.data;
          this.totalUsersSignedUp = response.data.totalUsers; // Total count of all users
          this.searchResultCount = response.data.searchResultCount; // Count of search results
          this.isInSearchMode = true;
        } else {
          // Handle no results
          alert("No customers found matching your search criteria");
        }
      } catch (error) {
        console.error("Error searching for specific user:", error);
        const errorMessage =
          error.response?.data?.message || "An error occurred during search";
        alert(errorMessage);
      } finally {
        this.searchLoading = false;
      }
    },

    clearAdvancedSearch() {
      // Reset search fields
      this.advancedSearch = {
        email: "",
        userId: "",
        customerCode: "",
      };

      // Restore original customers list
      if (this.isInSearchMode && this.originalCustomers.length > 0) {
        this.customers = [...this.originalCustomers];
        this.totalUsersSignedUp = this.originalCustomers.length;
        this.isInSearchMode = false;
      } else {
        // If something went wrong with storing original customers, fetch all again
        this.getCustomers();
      }
    },
  },
  watch: {
    "$route.name": {
      handler(e) {
        if (e == "Customers") {
          this.getCustomers();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* Custom styles for status column */
.bg-green-200 {
  background-color: #c6f6d5;
}
.text-green-800 {
  color: #22543d;
}
.bg-red-200 {
  background-color: #fed7d7;
}
.text-red-800 {
  color: #9b2c2c;
}

/* Add styles for the advanced search container */
.advanced-search-container {
  background-color: #f8f9fa;
  border-color: #e9ecef;
}
</style>
